import { render, staticRenderFns } from "./MultipleUserBooking.vue?vue&type=template&id=629a3f1b&"
import script from "./MultipleUserBooking.vue?vue&type=script&lang=js&"
export * from "./MultipleUserBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports